import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/AuthProvider";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserAfterGoogle } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUserAfterGoogle(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        setErr(e.response?.data?.detail || "Auth failed");
        setTimeout(() => navigate("/"), 1500);
      }
    })();
  }, [navigate, setUserAfterGoogle]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback">
      {err ? <div className="text-red-400">{err}</div> : (
        <div className="flex items-center gap-3 text-zinc-400">
          <Loader2 className="w-5 h-5 animate-spin text-scooter-yellow" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold">Authenticating...</span>
        </div>
      )}
    </div>
  );
}
